import {
  INavigationTree,
  INavigationTreeCategory,
  INavigationTreeSubcategory,
} from 'core/model/interfaces/navigation.interface';
import { IGetNavigationTreeDTO } from './navigation.dto';

export const navigationTreeDTOToNavigationTree = (tree: IGetNavigationTreeDTO): INavigationTree => {
  const { items } = tree;

  const categories: Array<INavigationTreeCategory> = items.map(
    item =>
      ({
        id: item.id,
        icon: item.iconUrl ?? '',
        name: item.name,
        url: item.navigationUri,
        subitems: item.subItems.map(
          subitem =>
            ({
              id: subitem.id,
              name: subitem.name,
              url: subitem.navigationUri,
              externalProductFamilyIds: [],
            } as INavigationTreeSubcategory),
        ),
      } as INavigationTreeCategory),
  );

  return {
    categories,
  };
};
